module.exports = __webpack_public_path__ + "static/media/2 5 Ordkjedetest-Riktig.acb76cd2.mp3";